import { Link, useParams } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import MovieBrowser from '@/components/feature/MovieBrowser';
import PageHeader from '@/components/feature/PageHeader';
import { usePageMeta } from '@/hooks/usePageMeta';

interface ListConfig {
  title: string;
  desc: string;
  genre?: string;
  special?: 'hot' | 'niche';
}

const listConfig: Record<string, ListConfig> = {
  action: { title: '动作片', desc: '紧张刺激的动作与犯罪题材影视推荐。', genre: '动作' },
  love: { title: '爱情片', desc: '浪漫细腻的爱情故事，甜蜜与感动并存。', genre: '爱情' },
  scifi: { title: '科幻片', desc: '探索浩瀚宇宙与未来科技的想象力之作。', genre: '科幻' },
  comedy: { title: '喜剧片', desc: '轻松解压的喜剧内容，笑料不断的欢乐时光。', genre: '喜剧' },
  suspense: { title: '悬疑片', desc: '抽丝剥茧的推理与烧脑悬念，让人欲罢不能。', genre: '悬疑' },
  history: { title: '古装剧', desc: '穿越千年的古装与武侠世界，家国与江湖并存。', genre: '古装' },
  niche: { title: '小众佳作', desc: '口碑出众但相对冷门的优质影视作品精选。', special: 'niche' },
  hot: { title: '热门推荐', desc: '当下热度最高的影视内容，追剧不迷路。', special: 'hot' },
};

export default function ListPage() {
  const { category = 'hot' } = useParams();
  const config = listConfig[category];
  const title = config ? config.title : '影视列表';
  const desc = config ? config.desc : '浏览影视作品列表。';

  usePageMeta(`${title} - 红桃影视`, desc);

  if (!config) {
    return (
      <div className="px-4 md:px-6 lg:px-10 py-20 text-center">
        <h1 className="text-2xl font-bold text-foreground-950">列表不存在</h1>
        <p className="mt-3 text-foreground-600">你访问的列表分类暂时不存在。</p>
        <Link
          to="/"
          className="inline-flex mt-6 px-6 h-11 items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          返回首页
        </Link>
      </div>
    );
  }

  let list = movies;
  if (config.genre) list = movies.filter((m) => m.genres.includes(config.genre as string));
  if (config.special === 'hot') list = movies.filter((m) => m.isHot);
  if (config.special === 'niche') list = movies.filter((m) => m.rating >= 8.5);

  return (
    <div className="pb-6">
      <PageHeader title={config.title} description={config.desc} items={[{ label: config.title }]} />
      <div className="px-4 md:px-6 lg:px-10 mt-6">
        <MovieBrowser movies={list} emptyText="该分类暂无相关内容" />
      </div>
    </div>
  );
}